import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import IconCheck from 'static/svg/done-24px.svg'
import { device, merchantThemes } from '../Variable'

export const LanguageSelectStyle = styled.div`
	display: block;
	width: ${rem(250)};
	@media (${device.mobileL}) {
		width: ${rem(60)};
	}
	.react-select {
		&__control {
			outline: none;
			width: 100%;
			box-shadow: none;
			border-color: ${({ theme }) => theme.color.grayOne};

			${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					border-color: ${({ theme }) => theme.color.primary};
				`}

			@media (${device.mobileL}) {
				min-height: ${rem(32)};
			}
			&:hover {
				border-color: ${({ theme }) => theme.color.grayOne};
			}
		}
		&__indicators {
			cursor: pointer;
		}
		&__indicator-separator {
			display: none;
		}
		&__dropdown-indicator {
			@media (${device.mobileL}) {
				padding: ${rem(4)};
			}
		}
		&__value-container {
			font-size: ${rem(18)};
			color: ${({ theme }) => theme.color.grayThree};
			font-weight: 600;
			padding: ${rem(0, 9)};

			${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					color: ${({ theme }) => theme.color.primary};
					font-weight: normal;
				`}
		}
		&__single-value {
			color: ${({ theme }) => theme.color.grayThree};

			${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					font-size: ${rem(14)};
					color: ${({ theme }) => theme.color.primary};
					font-weight: normal;
				`}

			@media (${device.mobileL}) {
				font-size: ${rem(14)};
			}
		}

		&__menu {
			margin-top: ${rem(3)};
			box-shadow: none;
			border: ${rem(1)} solid #5a5a5a;
		}

		&__option {
			font-size: ${rem(18)};
			color: ${({ theme }) => theme.color.grayThree};
			font-weight: 600;
			padding: ${rem(3, 9)};
			cursor: pointer;

			${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					font-size: ${rem(14)};
					color: ${({ theme }) => theme.color.primary};
					font-weight: normal;
				`}

			@media (${device.mobileL}) {
				font-size: ${rem(14)};
			}
			&--is-focused {
				background-color: #f6f6f6;
			}
			&--is-selected {
				background: #d7d6d7 url(${IconCheck}) no-repeat center right
					${rem(18)};
				@media (${device.mobileL}) {
					background: #d7d6d7;
				}
			}
		}
	}
`
